import './lib/jquery';
import './lib/fittext';
import ScrollMagic from 'scrollmagic';

import { preloader } from './components/preloader/index.js';

import initNav from './components/navigation/index.js';
import { clickScrollAction, popUpScene, popUpCloseScene } from './components/scrollMagic/index.js';
import { setContentSizes, contentSizingAjustments } from './components/helperFunc.js';
// import createGif from './components/gif/index.js';


import '../sass/retailactivationmemorialday.scss';

$(function() {
	preloader();
	initNav();
	// createGif();

	let controller = new ScrollMagic.Controller(); // Init ScrollMagic
	clickScrollAction(controller);
	popUpScene(controller);
	popUpCloseScene(controller);

	// contentSizingAjustments();
});

$(document).ready(() => {

	$(document).on('click', '.locator_container form input[type="submit"]', function(e) {
		e.preventDefault();
		let zip = $('#zip').val();
		let zipNums = parseInt(zip, 10);
		let zipLength = zip.length;

		let newURL;

		if (!!zipNums && zipLength === 5) {
			newURL = `${window.location.origin}/where-to-buy/?MM=panel2&ZIP=${zipNums}`;
		} else {
			newURL = `${window.location.origin}/where-to-buy/`;
		}

		window.location = newURL;
	});
});